export default __webpack_public_path__ + "static/media/firewall-negative.b09e9940.svg";